export default {
  type: "object",
  $id: "urn:jsonschema:eu:firstcare:api:v1:dto:serviceconfig:smsnotifications:SmsRestrictionDTO",
  required: ["startTime", "endTime"],
  properties: {
    startTime: {
      type: "string",
      title: "Start Time",
      oneOf: [
        { title: "00:00", const: "00:00" },
        { title: "01:00", const: "01:00" },
        { title: "02:00", const: "02:00" },
        { title: "03:00", const: "03:00" },
        { title: "04:00", const: "04:00" },
        { title: "05:00", const: "05:00" },
        { title: "06:00", const: "06:00" },
        { title: "07:00", const: "07:00" },
        { title: "08:00", const: "08:00" },
        { title: "09:00", const: "09:00" },
        { title: "10:00", const: "10:00" },
        { title: "11:00", const: "11:00" },
        { title: "12:00", const: "12:00" },
        { title: "13:00", const: "13:00" },
        { title: "14:00", const: "14:00" },
        { title: "15:00", const: "15:00" },
        { title: "16:00", const: "16:00" },
        { title: "17:00", const: "17:00" },
        { title: "18:00", const: "18:00" },
        { title: "19:00", const: "19:00" },
        { title: "20:00", const: "20:00" },
        { title: "21:00", const: "21:00" },
        { title: "22:00", const: "22:00" },
        { title: "23:00", const: "23:00" },
      ],
    },
    endTime: {
      type: "string",
      title: "End Time",
      oneOf: [
        { title: "00:00", const: "00:00" },
        { title: "01:00", const: "01:00" },
        { title: "02:00", const: "02:00" },
        { title: "03:00", const: "03:00" },
        { title: "04:00", const: "04:00" },
        { title: "05:00", const: "05:00" },
        { title: "06:00", const: "06:00" },
        { title: "07:00", const: "07:00" },
        { title: "08:00", const: "08:00" },
        { title: "09:00", const: "09:00" },
        { title: "10:00", const: "10:00" },
        { title: "11:00", const: "11:00" },
        { title: "12:00", const: "12:00" },
        { title: "13:00", const: "13:00" },
        { title: "14:00", const: "14:00" },
        { title: "15:00", const: "15:00" },
        { title: "16:00", const: "16:00" },
        { title: "17:00", const: "17:00" },
        { title: "18:00", const: "18:00" },
        { title: "19:00", const: "19:00" },
        { title: "20:00", const: "20:00" },
        { title: "21:00", const: "21:00" },
        { title: "22:00", const: "22:00" },
        { title: "23:00", const: "23:00" },
      ],
    },
  },
};
